/** Urutan & label tipe akun (standar laporan keuangan) */
export const COA_TYPE_ORDER = ['asset', 'liability', 'equity', 'revenue', 'expense'];

export const COA_TYPE_LABELS = {
  asset: 'Aset',
  liability: 'Kewajiban',
  equity: 'Ekuitas',
  revenue: 'Pendapatan',
  expense: 'Beban',
};

/** Kelas badge per tipe (outline + warna lembut) */
export const COA_TYPE_BADGE_CLASS = {
  asset: 'border-sky-200 bg-sky-50 text-sky-800',
  liability: 'border-amber-200 bg-amber-50 text-amber-900',
  equity: 'border-violet-200 bg-violet-50 text-violet-900',
  revenue: 'border-emerald-200 bg-emerald-50 text-emerald-900',
  expense: 'border-rose-200 bg-rose-50 text-rose-900',
};

/** Label sumber jurnal (sama untuk layar & CSV) */
export const JOURNAL_SOURCE_LABELS = {
  order_payment: 'Penjualan',
  manual: 'Manual',
  donation: 'Donasi',
  pakasir: 'Pakasir',
  cod_komship: 'COD',
};

export function journalSourceLabel(t) {
  return JOURNAL_SOURCE_LABELS[t] || t || '—';
}
